<template>
  <el-tree-select v-model="model" />
</template>

<script setup lang="ts">
defineOptions({
  name: 'TqSelectTree'
})
const model = defineModel()

</script>
